import { render } from "./AppFooter.vue?vue&type=template&id=5692a86c&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=5692a86c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5692a86c"]])

export default __exports__